import type { FunctionComponent } from "react";
import { Card, Text } from "~/components/ui";
import { PredefinedTaskIcon } from "./predefined-task-icon";
import { PredefinedTaskTitle } from "./predefined-task-title";

interface PredefinedTaskCardProps {
  order: number;
  title: string;
  description: string;
  icon: React.ReactNode;
  onSend: () => void;
}

export const PredefinedTaskCard: FunctionComponent<PredefinedTaskCardProps> = ({
  order,
  title,
  description,
  icon,
  onSend,
}) => {
  return (
    <Card hoverable className="cursor-pointer" bodyClassName="p-[18px]" onClick={onSend}>
      <div className="mb-3 flex items-center">
        <PredefinedTaskIcon icon={icon} />
        <PredefinedTaskTitle order={order} title={title} />
      </div>

      <Text tone="muted">{description}</Text>
    </Card>
  );
};
